import { QueryClient, type QueryClientConfig } from '@tanstack/react-query';

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      staleTime: 60 * 1000, // 30 seconds
      ...(process.env.NEXT_PUBLIC_ENV === 'production'
        ? {
            staleTime: 60 * 1000 * 5, // 5 minutes
          }
        : {}),
    },
  },
};

let browserQueryClient: QueryClient | undefined;

export const getBrowserQueryClient = (): QueryClient => {
  if (!browserQueryClient) {
    browserQueryClient = new QueryClient({
      ...queryClientConfig,
      defaultOptions: {
        ...queryClientConfig.defaultOptions,
        queries: {
          ...queryClientConfig.defaultOptions?.queries,
          refetchOnWindowFocus: false,
          refetchOnMount: false,
          refetchOnReconnect: false,
        },
      },
    });
  }
  return browserQueryClient;
};
